import { render, staticRenderFns } from "./MemberRoleInput.vue?vue&type=template&id=0bdf8f5f&scoped=true"
import script from "./MemberRoleInput.vue?vue&type=script&lang=js"
export * from "./MemberRoleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf8f5f",
  null
  
)

export default component.exports